import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <div className="page narrow">
      <div className="pagehead">
        <div>
          <h2 className="pagetitle">Nothing here</h2>
          <p className="pagesub">That address is not part of the War Room.</p>
        </div>
        <Link className="btn btn-sm btn-solid" to="/">
          Back to the board
        </Link>
      </div>
    </div>
  );
}
